import Model from './Model'
export default class OfferProduct extends Model {

    resource()
    {
        return 'offer-products'
    }

    get measurements() {
        return [{
            value: 'BUC',
            text: 'BUC'
        }, {
            value: 'LITRU',
            text: 'LITRU'
        }, {
            value: 'KG',
            text: 'KG'
        }, {
            value: 'ML',
            text: 'ML'
        }, {
            value: 'MC',
            text: 'MC'
        }, {
            value: 'MP',
            text: 'MP'
        }, {
            value: 'T',
            text: 'T'
        }, {
            value: 'ORA',
            text: 'ORA'
        }, {
            value: 'KM',
            text: 'KM'
        }]
    }
}
